import {
  AdminProvidersManagement,
  UserProvidersManagement,
} from 'pages/providers/components';

import { useCanAccess } from 'hooks/useCanAccess';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';

export const ProviderManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('providers');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminProvidersManagement />
  ) : canAccess ? (
    <UserProvidersManagement />
  ) : (
    <Unauthorized />
  );
};
